import { Dispatch, SetStateAction, useEffect, useState } from 'react';

const lsWrite = <T>(key: string, value: T) => {
  const str = JSON.stringify(value);
  window.localStorage.setItem(key, str);
};

const lsRead = <T>(key: string): T | null => {
  const str = window.localStorage.getItem(key);
  return str ? JSON.parse(str) : (str as T);
};

const lsClear = (key: string) => {
  window.localStorage.removeItem(key);
};

export const useStickyState = <T>(
  key: string,
  initialState: T
): [state: T, setState: Dispatch<SetStateAction<T>>, clearState: () => void] => {
  const [state, setState] = useState<T>(() => {
    const storedState = lsRead(key) as T;
    return storedState ?? (initialState as T);
  });

  useEffect(() => {
    lsWrite(key, state);
  }, [state, key]);

  const clearState = () => {
    setState(initialState);
    lsClear(key);
  };

  return [state, setState, clearState];
};
